define('collections/calendar/session/exercise/cardio/phase-weeks',[
    'underscore',
    'backbone',
    'utils',
    // Pull in the Model module from above
    'models/calendar/session/exercise/cardio/phase-week'
], function(
    // libs
    _, Backbone, U,
    // model
    MPhaseWeek
) {

    var CPhaseWeeks = Backbone.Collection.extend({
        model: MPhaseWeek,


        applyWeek: function(week, skip) {
            // if (_.isUndefined(skip)) {
            //     skip = 0;
            // }
            //
            // var appliedWeek = week.toJSON();
            // // appliedWeek.index = skip + 1;
            //
            // this.chain().rest(Number(skip)).each(function(model) {
            //     model.set(appliedWeek);
            //     // appliedWeek.index++;
            // });

        },

        pushWeek: function(count, options) {
            var models = [];
            while (count-- > 0) { // while count down to zero
                models.push(new MPhaseWeek());
            }
            return this.push(models, options);
        },

        popWeek: function(count, options) {
            var models = this.rest(this.length - count);
            return this.remove(models, options);
        },

        ////////////
        // events //
        ////////////
        onNumWeekChange: function(value) {
            var changes = value - this.length;
            this[changes < 0 ? "popWeek" : "pushWeek"](Math.abs(changes));
        },


    });

    return CPhaseWeeks;
});

